var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FileList mt-2"},_vm._l((_vm.files),function(file){return _c('div',{key:`file_${file.uuid}`,staticClass:"d-inline-flex w-100"},[_c('FileUuidDownloadLink',_vm._g({attrs:{"uuid":file.uuid,"icon":true,"disconnect":true,"disabled":_vm.disabled,"filenameprefix":_vm.filenameprefix}},_vm.$listeners))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }